import InterfaceAccountActions, { ACCOUNT_ACTION_IDS } from '@central-products/interface-account-actions';
import { getDeviceInfo } from '@sitebase/device-detector';
import { NAVIGATION_TARGETS } from './enums';
import { HandlerPayload, NavigationPayload } from './typings';

export const executeAction = ({ target, url }: NavigationPayload) => {
  // fix for #SWM-77 (window.open doesn't work in iOS native app)
  // so we ignore target value for native iOs
  const { isIosNative } = getDeviceInfo();
  if (isIosNative) {
    window.location.assign(url);
  } else if (target === NAVIGATION_TARGETS.SELF) {
    window.location.assign(url);
  } else {
    window.open(url, target);
  }
};

export default ({ transport }: HandlerPayload) => {
  const accountActionsProxy = transport.get<InterfaceAccountActions>(InterfaceAccountActions);

  accountActionsProxy.onActionRequested(({ actionId, context }) => {
    if (actionId === ACCOUNT_ACTION_IDS.NAVIGATE_TO) {
      executeAction(context.data);
    }
  });
};
